import { React, useEffect, useRef, createRef, Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadUserSessionStorage } from '../../../../utils/helpers.utils';
import { translationAction } from '../../../../store/external/translation-reducer/translation.reducer';
import Translation from "../../../common/translation/translation.component"
import "./language.component.css";

class LangSwitchContainer extends Component {
    constructor(props) {
        super();
        this.state = ({
            showClass: "",
        })
        this.wrapperRef = createRef();
    }

    checkIfClickedOutside = (e) => {
        if (
            this.props.navToggle &&
            this.wrapperRef.current &&
            !this.wrapperRef.current.contains(e.target)
        ) {
            this.props.onClose();
        }
    }

    componentDidMount() {
        const { languages, getToolLanguages, setLanguage } = this.props;
        if (languages.length === 0) {
            getToolLanguages();
        }
        if (loadUserSessionStorage() !== null && loadUserSessionStorage().Employee.LanguageLocale !== null && loadUserSessionStorage().Employee.LanguageLocale !== '') {
            setLanguage(loadUserSessionStorage().Employee.LanguageLocale);
            sessionStorage.setItem('Current_Language', loadUserSessionStorage().Employee.LanguageLocale);
        }
        window.addEventListener('mousedown', this.checkIfClickedOutside)
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.checkIfClickedOutside)
    }

    render() {
        const { languages, setLangConfodalOpen, locale } = this.props;
        return (
            <div className="external-languange-nav" ref={this.wrapperRef}>
                {languages.length > 0 ?
                    <div>
                        <p className="nav-title">
                            <Translation translationKey="select_language" />
                        </p>
                        <div className="external-language-list">
                        {languages.map((language, i) =>
                            <p
                                key={i}
                                className={this.props.locale === language.Key ? 'font-weight-bold' : ''}
                                onClick={() => setLangConfodalOpen(true, language.Key)}>
                                {language.Value}
                            </p>
                        )}
                        </div>
                    </div>
                    : ""
                }
                </div>
        );
    }
}


export default connect(
    state => state.translation,
    dispatch => bindActionCreators(translationAction, dispatch)
)(LangSwitchContainer);
